import { getDefaultData } from '../../data/resources/get-default-data';
import { ResourceLinks } from '../../data/resources/resource-links';
import {
  LinksColumnTitle,
  LinksContainer,
  LinksSubContainer,
  NavLink,
  SectionSubTitle,
  SectionTitle,
  TitleContainer,
} from '../HeaderSubmenuMobile.style';
import { navigation } from '@exploration/cms-constants';

export const ResourcesMobileMenu = () => {
  const cmsData = getDefaultData();
  return (
    <>
      <TitleContainer>
        <SectionTitle>
          {
            cmsData?.text?.[
              navigation.resources_navigation_links.resources_title
            ]
          }
        </SectionTitle>
        <SectionSubTitle>
          {
            cmsData?.text?.[
              navigation.resources_navigation_links.resources_description
            ]
          }
        </SectionSubTitle>
      </TitleContainer>
      <LinksContainer>
        <LinksSubContainer>
          <LinksColumnTitle>
            {
              cmsData?.text?.[
                navigation.resources_navigation_links.resources_learn_title
              ]
            }
          </LinksColumnTitle>
          {ResourceLinks.learnLinks.map((learnLink) => {
            return (
              <NavLink
                key={learnLink.label}
                href={learnLink.url}
                target={learnLink.target}
              >
                {learnLink.label}
              </NavLink>
            );
          })}
        </LinksSubContainer>
        <LinksSubContainer>
          <LinksColumnTitle>
            {
              cmsData?.text?.[
                navigation.resources_navigation_links.resources_get_help_title
              ]
            }
          </LinksColumnTitle>
          {ResourceLinks.getHelpLinks.map((getHelpLink) => {
            return (
              <NavLink
                key={getHelpLink.label}
                href={getHelpLink.url}
                target={getHelpLink.target}
              >
                {getHelpLink.label}
              </NavLink>
            );
          })}
        </LinksSubContainer>
      </LinksContainer>
    </>
  );
};
